import type { Team } from '@entities/team';
import type { TeamListRepository } from '@infra/repositories/team.repository';

export class MemTeamRepository implements TeamListRepository {
  private _team?: Team[];

  constructor(teams: Team[] = []) {
    this._team = teams;
  }

  getTeams(): Promise<Team[]> {
    return Promise.resolve(this._team as Team[]);
  }

  async addTeam(team: Team[]): Promise<void> {
    this._team = this._team?.concat([...team]);
  }

  async updateTeams(teams: Team[]): Promise<void> {
    this._team = [...teams];
  }
}
